export var PurposeBuilding;
(function (PurposeBuilding) {
    PurposeBuilding["LargePanelBuilding"] = "LargePanelBuilding";
    PurposeBuilding["FramePanelBuilding"] = "FramePanelBuilding";
})(PurposeBuilding || (PurposeBuilding = {}));
export var RuPurposeBuildingSelectValues = [
    { label: 'Крупнопанельное здание', value: PurposeBuilding.LargePanelBuilding },
    { label: 'Каркасно-панельное здание', value: PurposeBuilding.FramePanelBuilding },
];
